var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activity)?_c('dt',[_vm._v(_vm._s(_vm.activity.taskName))]):_vm._e(),(_vm.resourceType)?_c('dd',[_vm._v(_vm._s(_vm.resourceType.name))]):_vm._e(),(_vm.unit)?_c('dd',[_vm._v(_vm._s(_vm.unit.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }